import * as React from 'react';
import { ErrorBoundary } from '@components/common';
import * as Store from './store';
import FilterDialogMain from './Main';

export interface FilterDialogProps extends Store.FilterDialogContextProps {
  defaultValue?: Store.FilterDialogContextProps['value'];
}

export interface FilterDialogRef extends Store.FilterDialogProviderRef {}

const FilterDialog = React.forwardRef<FilterDialogRef, FilterDialogProps>((props, ref) => {
  const { defaultValue, value, onChange, ...params } = props;

  const innerValue = React.useMemo(
    () => value || defaultValue,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [value],
  );
  // Clear the internal modified flag by structured clone
  const innerOnChange = React.useCallback((v) => onChange?.(structuredClone(v)), [onChange]);

  return (
    <ErrorBoundary>
      <Store.FilterDialogProvider {...params} ref={ref} value={innerValue} onChange={innerOnChange}>
        <FilterDialogMain />
      </Store.FilterDialogProvider>
    </ErrorBoundary>
  );
});

FilterDialog.displayName = 'FilterDialog';

export default React.memo(FilterDialog);
